module.exports = __webpack_public_path__ + "img/hip_and_valley.8d60728e.jpg";